(() => {
 function init(root) {
  if (root.dataset.hwReady) return;
  root.dataset.hwReady = 'true';
  const classic = root.querySelector('[data-hw-classic]');
  const enhanced = root.querySelector('[data-hw-enhanced]');
  const inside = root.querySelector('[data-hw-inside]');
  const classicAlt = classic.alt;
  const editions = [...root.querySelectorAll('[data-hw-edition]')];
  const views = [...root.querySelectorAll('[data-hw-view]')];
  const selector = root.querySelector('.hw-editions');
  const swatches = root.querySelector('.hw-swatches');
  const colors = [...root.querySelectorAll('[data-hw-color]')];
  const colorLayers = [...root.querySelectorAll('[data-hw-color-layer]')];
  const colorStatus = root.querySelector('[data-hw-color-status]');
  function render() {
   const interior = root.dataset.view === 'inside';
   const extra = root.dataset.edition === 'enhanced';
   const chosen = root.dataset.hwColor || 'green';
   selector.hidden = interior;
   swatches.hidden = interior || !extra;
   [[classic, !interior && !extra, classicAlt], [enhanced, !interior && extra && chosen === 'green', enhanced.dataset.alt], [inside, interior, inside.dataset.alt]].forEach(([image, active, alt]) => {
    image.alt = active ? alt : '';
    image.setAttribute('aria-hidden', String(!active));
   });
   colorLayers.forEach(image => {
    const active = !interior && extra && chosen === image.dataset.hwColorLayer;
    image.alt = active ? image.dataset.alt : '';
    image.setAttribute('aria-hidden', String(!active));
   });
   colors.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hwColor === chosen)));
   colorStatus.textContent = extra && !interior ? chosen.replace('-', ' ') + ' spotlight preview' : '';
   editions.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hwEdition === root.dataset.edition)));
   views.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hwView === root.dataset.view)));
  }
  editions.forEach(b => b.addEventListener('click', () => { root.dataset.edition = b.dataset.hwEdition; render(); }));
  views.forEach(b => b.addEventListener('click', () => { root.dataset.view = b.dataset.hwView; render(); }));
  colors.forEach(b => b.addEventListener('click', () => { root.dataset.hwColor = b.dataset.hwColor; render(); }));
  render();
 }
 const start = () => document.querySelectorAll('[data-gob-71043-story]').forEach(init);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
 document.addEventListener('shopify:section:load', start);
})();